import styled from 'styled-components';
import { RightArrowIcon } from '@karma/components/icons';

export const LeaveIcon = styled(RightArrowIcon)`
  transform: rotate(315deg);
`;
